export default __webpack_public_path__ + "static/media/illustration-recruit-2-w@3x.3f4c57eb.webp";